const allCities = [
  { name: "Albany", route: "/cities/albany-ga", tagline: "Southwest Georgia expedited passport services", highlights: ["Dougherty County coverage", "Serving Lee, Worth, Terrell counties"] },
  { name: "Alpharetta", route: "/cities/alpharetta", tagline: "North Fulton County expedited passport processing", highlights: ["Alpharetta area coverage", "Serving Johns Creek, Roswell, Milton"] },
  { name: "Athens", route: "/cities/athens", tagline: "Clarke County passport services near UGA", highlights: ["University of Georgia area", "Serving Oconee, Oglethorpe, Madison counties"] },
  { name: "Atlanta", route: "/cities/atlanta", tagline: "Metro Atlanta's trusted expedited passport hub", highlights: ["Same-day options available", "Serving Decatur, Sandy Springs, Marietta"], badge: "Most Popular" },
  { name: "Augusta", route: "/augusta", tagline: "Richmond County expedited passport services", highlights: ["Augusta area coverage", "Serving North Augusta, Aiken SC, Martinez"] },
  { name: "Buckhead", route: "/cities/buckhead", tagline: "North Atlanta expedited passport services in upscale Buckhead", highlights: ["Buckhead area coverage", "Serving Midtown, Brookhaven, Sandy Springs"] },
  { name: "Carrollton", route: "/cities/carrollton", tagline: "West Georgia expedited passport processing", highlights: ["Carroll County coverage", "Serving Villa Rica, Bremen, Temple"] },
  { name: "Columbus", route: "/cities/columbus", tagline: "Muscogee County expedited passport services", highlights: ["Fort Benning area coverage", "Serving Phenix City AL, Harris County"] },
  { name: "Dalton", route: "/cities/dalton", tagline: "Whitfield County expedited passport processing", highlights: ["Carpet Capital coverage", "Serving Chatsworth, Ringgold, Tunnel Hill"] },
  { name: "Decatur", route: "/cities/decatur", tagline: "DeKalb County expedited passport services", highlights: ["Decatur area coverage", "Serving Avondale Estates, Clarkston, Stone Mountain"] },
  { name: "Douglasville", route: "/cities/douglasville", tagline: "Douglas County expedited passport processing", highlights: ["Douglasville area coverage", "Serving Lithia Springs, Villa Rica, Hiram"] },
  { name: "Duluth", route: "/cities/duluth", tagline: "Gwinnett County expedited passport services", highlights: ["Duluth area coverage", "Serving Suwanee, Lawrenceville, Norcross"] },
  { name: "Dunwoody", route: "/cities/dunwoody", tagline: "DeKalb County northern passport hub", highlights: ["Dunwoody area coverage", "Serving Sandy Springs, Chamblee, Brookhaven"] },
  { name: "Gainesville", route: "/cities/gainesville-ga", tagline: "Hall County expedited passport services", highlights: ["Lake Lanier area coverage", "Serving Flowery Branch, Oakwood, Braselton"] },
  { name: "Hinesville", route: "/cities/hinesville", tagline: "Liberty County expedited passport processing", highlights: ["Fort Stewart area coverage", "Serving Midway, Richmond Hill, Ludowici"] },
  { name: "Johns Creek", route: "/cities/johns-creek", tagline: "North Fulton County passport services", highlights: ["Johns Creek area coverage", "Serving Alpharetta, Duluth, Suwanee"] },
  { name: "Kennesaw", route: "/cities/kennesaw", tagline: "Cobb County expedited passport processing", highlights: ["Kennesaw area coverage", "Serving Acworth, Marietta, Woodstock"] },
  { name: "LaGrange", route: "/cities/lagrange", tagline: "Troup County expedited passport services", highlights: ["LaGrange area coverage", "Serving West Point, Hogansville"] },
  { name: "Lawrenceville", route: "/cities/lawrenceville", tagline: "Gwinnett County expedited passport processing", highlights: ["Lawrenceville area coverage", "Serving Snellville, Grayson, Dacula"] },
  { name: "Macon", route: "/cities/macon", tagline: "Bibb County expedited passport services", highlights: ["Macon area coverage", "Serving Warner Robins, Perry, Forsyth"] },
  { name: "Marietta", route: "/cities/marietta", tagline: "Cobb County expedited passport processing", highlights: ["Marietta area coverage", "Serving Smyrna, Kennesaw, Acworth"] },
  { name: "Milledgeville", route: "/cities/milledgeville", tagline: "Baldwin County expedited passport services", highlights: ["Milledgeville area coverage", "Serving Eatonton, Gordon, Gray"] },
  { name: "Milton", route: "/cities/milton", tagline: "North Fulton County expedited passport processing for affluent suburban travelers", highlights: ["North Fulton County coverage", "Serving Alpharetta, Roswell, Johns Creek, Cumming"] },
  { name: "Newnan", route: "/cities/newnan", tagline: "Coweta County expedited passport processing", highlights: ["Newnan area coverage", "Serving Peachtree City, Senoia, Sharpsburg"] },
  { name: "Peachtree Corners", route: "/cities/peachtree-corners", tagline: "Western Gwinnett County expedited passport processing", highlights: ["Peachtree Corners area coverage", "Serving Norcross, Duluth, Johns Creek, Sandy Springs"] },
  { name: "Peachtree City", route: "/cities/peachtree-city", tagline: "Fayette County expedited passport services", highlights: ["Peachtree City area coverage", "Serving Newnan, Fayetteville, Tyrone"] },
  { name: "Rome", route: "/cities/rome", tagline: "Floyd County expedited passport processing", highlights: ["Rome area coverage", "Serving Calhoun, Summerville, Cedartown"] },
  { name: "Roswell", route: "/cities/roswell", tagline: "North Fulton County expedited passport services", highlights: ["Roswell area coverage", "Serving Alpharetta, Milton, Woodstock"] },
  { name: "Sandy Springs", route: "/cities/sandy-springs", tagline: "North Fulton expedited passport services near Atlanta", highlights: ["Sandy Springs area coverage", "Serving Dunwoody, Roswell, Alpharetta, Johns Creek"] },
  { name: "Savannah", route: "/cities/savannah", tagline: "Chatham County coastal passport hub", highlights: ["Historic Savannah coverage", "Serving Pooler, Richmond Hill, Tybee Island"] },
  { name: "Smyrna", route: "/cities/smyrna", tagline: "Cobb County expedited passport processing", highlights: ["Smyrna area coverage", "Serving Vinings, Mableton, Austell"] },
  { name: "Statesboro", route: "/cities/statesboro", tagline: "Bulloch County expedited passport services", highlights: ["Georgia Southern area coverage", "Serving Metter, Sylvania, Claxton"] },
  { name: "Suwanee", route: "/cities/suwanee", tagline: "Gwinnett County expedited passport processing", highlights: ["Suwanee area coverage", "Serving Johns Creek, Duluth, Lawrenceville, Sugar Hill"] },
  { name: "Valdosta", route: "/cities/valdosta", tagline: "Lowndes County expedited passport processing", highlights: ["Valdosta area coverage", "Serving Hahira, Lake Park, Quitman"] },
  { name: "Warner Robins", route: "/cities/warner-robins", tagline: "Houston County expedited passport services", highlights: ["Robins AFB area coverage", "Serving Perry, Byron, Fort Valley"] },
  { name: "Woodstock", route: "/cities/woodstock", tagline: "Cherokee County expedited passport processing", highlights: ["Woodstock area coverage", "Serving Canton, Holly Springs, Ball Ground"] },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function GeorgiaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Georgia Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Georgia Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) => (
              <a
                key={i}
                href={city.route}
                className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
              >
                {city.badge && (
                  <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {city.badge}
                  </span>
                )}
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                    <p className="text-gray-400 text-xs">Georgia</p>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                <ul className="space-y-2 mb-6 flex-1">
                  {city.highlights.map((h, j) => (
                    <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                      {h}
                    </li>
                  ))}
                </ul>
                <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                  View Services{" "}
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </a>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Georgia locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}